const translations = {
    // Origens
    "null": "Todos",
    "SENTRY-OCCURRENCE": "Sentry",
    "EXTERN-MJ": "Córtex",
    "EXTERN-CELEPAR": "Celepar",
    "EXTERN-DETRANES": "DETRAN-ES",
    "EXTERN-PRF": "PRF",
    "SESP_SP": "Muralha Paulista",
    "MURALHA PAULISTA": "Muralha Paulista",
    "PMERJ": "PMERJ",
    "EXTERN-PMERJ": "PMERJ",
    "eventSource.PMERJ": "PMERJ",
    "EXTERN-DETRAN_AM": "DETRAN-AM",
    "EXTERN-SESP_SP": "Muralha Paulista",

    // Avisos
    'WARNING': 'Advertência',
    'APPREHENSION': 'Apreensão',
    'EMBARGO': 'Embargo',
    'CLOSURE': 'Fechamento',
    'INTERDICTION': 'Interdição',
    'SEALING': 'Lacração',
    'FINE': 'Multa',
    'NOTIFICATION': 'Notificação',
    'ORIENTATION': 'Orientação',
    'REMOVAL': 'Remoção',
    'PARTIAL_SUSPENSION': 'Suspensão Parcial',
    'TOTAL_SUSPENSION': 'Suspensão Total',

    // Gênero
    'FEMALE': 'Feminino',
    'MALE': 'Masculino',

    // Assinatura
    'DENIED': 'Negou-se a assinar',
    'UNABLE': 'Impossibilitado de assinar',
    'SIGNATURE': 'Assinatura',

    // Estado civil
    'MARRIED': 'Casado(a)',
    'DIVORCED': 'Divorciado(a)',
    'SEPARATED': 'Separado(a)',
    'SINGLE': 'Solteiro(a)',
    'STABLE_UNION': 'União estável',
    'WIDOWER': 'Viúvo(a)',

    // Áreas
    'ANTRHOPIZED': 'Antropizada',
    'APP': 'APP - Área de Preservação',
    'RURAL': 'Rural',
    'UC': 'UC - Unidade de Conservação',
    'URBAN': 'Urbana',
    'DAMPING_ZONE': 'Zona de Amortecimento',

    // Unidades
    'MILLIGRAM': 'Miligrama (mg)',
    'GRAM': 'Grama (g)',
    'KILOGRAM': 'Quilograma (Kg)',
    'MILLILITER': 'Mililitro (mL)',
    'LITER': 'Litro (L)',
    'CENTIMETER': 'Centímetro (cm)',
    'METER': 'Metro (m)',
    'PIECE': 'Peça (pç)',
    'UNITY': 'Unidade (un)',

    // Ações
    'PRISONER_DELIVERY': 'Auto de entrega de preso',
    'EXHIBITION_AND_APPREHENSION': 'Auto de exibição e apreensão',
    'DRUNKENNESS_TERM': 'Termo de Constatação de Embriaguez',
    'BREATHALYZER_TEST': 'Teste Etilômetro',
    'VEHICLE_SEIZURE_NOTICE': 'Guia de Recolhimento de Veículo',
    'CRLV_SEIZURE_NOTICE': 'Guia de Recolhimento de CRLV',
    'ARREST_WARRANT': 'Mandado de prisão',
    'VEHICLE_IDENTIFICATION_IC': 'Laudo de constatação IC',
    'ASSESSMENT': 'Autuação',
    'BOPC': 'BOPC',
    'BOPM': 'BOPM',
    'MEDICAL_REPORT': 'Laudo médico',
    'OTHERS': 'Outros',
    'TEST_REPORT': 'Relatório de ensaio',
    'ROF': 'ROF',
    'TESTIMONIAL_TERM': 'Termo de depoimento',
    'PROTECTIVE_MEASURE': 'Medida Protetiva',
    'POLICE_REPORT': 'Termo circunstanciado',
    'OAB': 'OAB',
    'CREA': 'CREA',
    'CRM': 'CRM',
    'MEDICAL_ASSISTANCE_REPORT': 'Boletim de Atendimento Médico (BAM)',
    'REFERRAL_CEAM': 'Encaminhamento ao CEAM',
    'ADDITIVE_TERM': 'Termo aditivo',
    'SARPAS_PROTOCOL': 'Protocolo SARPAS',

    'NEW_WEB': 'Cadastro pela web',
    'NEW_MOBILE': 'Cadastro pelo app',
    'ACTIVATION': 'Ativação',
    'INACTIVATION': 'Inativação - Outros',
    'INACTIVATION_REFUSAL': 'Inativação - Recusa',
    'INACTIVATION_REVOCATION': 'Inativação - Revogação',
    'INACTIVATION_TERMINATION': 'Inativação - Desligamento',
    'INTERVIEW': 'Entrevista',
    'ATTENDANCE': 'Atendimento',
    'PATROL': 'Ronda',
    'CALL': 'Ligação',
    'VISIT': 'Visita',
    'REFERRED': 'Encaminhamento',
    'COMMENT': 'Comentário',
    'EVENT_START': 'SOS - aberto',
    'EVENT_TARGET_ADDRESS': 'SOS - endereço selecionado',
    'EVENT_TARGET_CITIZEN': 'SOS - cidadão selecionado',
    'EVENT_ACK': 'SOS - assumido',
    'EVENT_END': 'SOS - finalizado',
    'PASSWORD_CHANGE': 'Mudança de senha',
    'PASSWORD_RECOVERY': 'Recuperação de senha',
    'GUIDANCE': 'Orientação',

    // Status
    'INVALIDATED': 'Invalidado',
    'PENDING': 'Pendente (aprovação)',
    'REJECTED': 'Reprovado',
    'APPROVED': 'Aprovado',
    'REVIEWED': 'Revisado',
    'NUMBER_GENERATED': 'Numeração gerada',
    'DRAFT': 'Em preenchimento',
    'APP_DELETED': 'Excluído (app)',
    'SYSTEM_DELETED': 'Excluído (sistema)',
    'FILE_SENT': 'Documento enviado',

    // Classificações
    'AUTOR': 'Autor',
    'AVERIGUACAO_CLONE': 'Averiguação de clone',
    'CITADO': 'Citado',
    'ENVOLVIDO': 'Envolvido',
    'FURTADO': 'Furtado',
    'NAO_RELACIONADO': 'Não relacionado',
    'OUTRO': 'Outro',
    'PRODUTO': 'Produto',
    'RECUPERADO': 'Recuperado',
    'ROUBADO': 'Roubado',
    'SUSPEICAO_FRACA': 'Suspeição fraca',
    'SUSPEITO': 'Suspeito',
    'VITIMA': 'Vítima',

    // Dias da semana
    '0': 'Domingo',
    '1': 'Segunda-feira',
    '2': 'Terça-feira',
    '3': 'Quarta-feira',
    '4': 'Quinta-feira',
    '5': 'Sexta-feira',
    '6': 'Sábado',

    // Campos sem preenchimento
    'without_lat': "Latitude/Longitude",
    'without_obs': "Observação inicial",
    'without_final_obs': "Observação final",
    'without_neigh': "Bairro",
    'without_nature': "Natureza",
    'without_number': "Número",
    'without_sector': "Setor",
    'without_street': "Logradouro",
    'without_place': "Local pré-cadastrado",

    // Meses
    '01': 'Janeiro',
    '02': 'Fevereiro',
    '03': 'Março',
    '04': 'Abril',
    '05': 'Maio',
    '06': 'Junho',
    '07': 'Julho',
    '08': 'Agosto',
    '09': 'Setembro',
    '10': 'Outubro',
    '11': 'Novembro',
    '12': 'Dezembro',

    // Booleano
    'true': 'Sim',
    'TRUE': 'Sim',
    'false': 'Não',
    'FALSE': 'Não',

    // Encaminhamentos
    'SHELTER': 'Abrigo',
    'SOCIAL_ASSISTENCE': 'Assistência Social',
    'BTLPM': 'BTL. PM',
    'HOMELESS_HELP_CENTER': 'Centro POP',
    'TUTELARY_COUNCIL': 'Conselho Tutelar',
    'POLICE_STATION': 'Delegacia',
    'POLICE_STATION_ASSESSED': 'Delegacia e autuado',
    'POLICE_STATION_DETAINED': 'Delegacia e detido',
    'POLICE_STATION_RELEASED': 'Delegacia e liberado',
    'NONE': 'Não houve',
    'FIRST_AID': 'Pronto Socorro',
    'UPA': 'UPA',

    // Relatórios
    'id': 'ID',
    'name': 'Nome',
    'description': 'Descrição',
    'garrison_group': 'Função destinada',
    'auto_apply_by_group': 'Atribuir automaticamente às guarnições',
    'inactive': 'Inativo',
    'inactive_observation': 'Motivo da inativação',
    'hours': 'Horário',
    'duration': 'Duração',
    'priority': 'Prioridade',
    'reason': 'Natureza',
    'address': 'Endereço',
    'sector': 'Setor',
    'sectors': 'Setores',
    'schedule-garrison_message': 'Descrição do anexo',

    // Endereço
    'district': 'UF',
    'city': 'Cidade',
    'placeType': 'Tipo do local',
    'place': 'Local',
    'street': 'Logradouro',
    'number': 'Número',
    'neighborhood': 'Bairro',
    'complement': 'Complemento',
    'zipCode': 'CEP',
    'crossroad': 'Cruzamento',
    'referencePoint': 'Ponto de referência',

    // Mapa
    'latitude': 'Latitude',
    'longitude': 'Longitude',

    // Horário
    'FIXED': 'Horário fixo',
    'INTERVAL': 'Intervalo permitido para iniciar a atividade',
    'WITHOUT_HOUR': 'Horário livre',
    'type': 'Tipo',
    'startHour': 'Horário inicial',
    'endHour': 'Horário final',
    'startChangeDay': 'Dia seguinte',
    'endChangeDay': 'Dia seguinte',
    'changeDay': 'Dia seguinte',
    'allowRepeat': 'Permite repetição',
    'durationInMinutes': 'Duração em minutos',

    // Grupo de operação
    'ADMINISTRATION': 'Administração',
    'FIXED_LOCATION': 'Posto fixo',
    'PATROLLING': 'Patrulhamento',

    // Referência
    'old': 'Antigo',
    'new': 'Novo',
    'start': 'Início',
    'middle': 'Meio',
    'end': 'Fim',

    // Sistema
    'system': 'Sistema',
    'SYSTEM': 'Sistema',

    'FILE': 'Arquivo',
    'REPORT': 'Relatório',
    'CLIPBOARD': 'Área de transferência',
};

export const translate = (value) => {
    return translations[value] ?? value;
};